(function(){
  'use strict';

  angular
    .module('app')
    .component('modal', modalComponent());

  function modalComponent() {
    return {
      template: `
        <div class="modal" ng-class="{'modal--active': vm.open}" ng-transclude></div>
        <div class="overlay-modal" ng-keydown="vm.closeModal()" ng-click="vm.closeModal()" ng-class="{'overlay-modal--active': vm.open}"></div>
      `,
      bindings: { open: '=' },
      controller: ModalController,
      controllerAs: 'vm',
      transclude: true
    }
  }

  function ModalController($scope) {
    const vm = this;
    const body = angular.element(document).find('body');

    vm.closeModal = () => {vm.open = false};

    body
      .bind("keydown", event => {
        if(event.keyCode != 27) return;
        vm.closeModal();
      });
  }

})();
